
import { Component, Vue, Watch } from 'vue-property-decorator'
import nl_NL from 'ant-design-vue/lib/locale-provider/nl_NL'
import moment from 'moment'
import 'moment/locale/nl'
import Navigation from '@/components/base/Navigation.vue'
import HeaderBar from '@/components/base/HeaderBar.vue'
import { realtimeService, RealtimeUnsubscribe } from '@/services/realtime'
moment.locale('nl')

interface PermissionsChangedEvent {
  permissions: string[]
}

interface RolesChangedEvent {
  roles: string[]
}

@Component({
  components: { Navigation, HeaderBar }
})

export default class App extends Vue {
  locale = nl_NL
  userEventSubscriptions: RealtimeUnsubscribe[] = []

  @Watch('realtimeIdentity', { immediate: true })
  onRealtimeIdentityChanged () : void {
    this.initRealtime()
  }

  beforeDestroy () : void {
    this.clearUserEventSubscriptions()
    realtimeService.disconnect()
  }

  initRealtime () : void {
    this.clearUserEventSubscriptions()

    const token = this.authToken
    const userId = this.$store.getters['authStore/authUser']?.id
    if (!token || !userId) {
      realtimeService.disconnect()
      return
    }

    realtimeService.connect(token, userId)
    const userChannel = `App.Models.User.${userId}`
    this.userEventSubscriptions = [
      realtimeService.listenPrivate(userChannel, '.permissions.changed', (event: PermissionsChangedEvent) => {
        this.$store.dispatch('authStore/setPermissions', event.permissions)
      }),
      realtimeService.listenPrivate(userChannel, '.roles.changed', (event: RolesChangedEvent) => {
        this.$store.dispatch('authStore/setRoles', event.roles)
      })
    ]
  }

  clearUserEventSubscriptions () : void {
    this.userEventSubscriptions.forEach(unsubscribe => unsubscribe())
    this.userEventSubscriptions = []
  }

  get isLoggedIn () : boolean {
    return this.$store.getters['authStore/isLoggedIn']
  }

  get authToken () : string {
    return this.$store.getters['authStore/authToken']
  }

  get realtimeIdentity () : string {
    const userId = this.$store.getters['authStore/authUser']?.id || ''
    return `${this.authToken}:${userId}`
  }

  get currentYear () : number {
    return moment().year()
  }

  get appVersion () : string {
    return process.env.VUE_APP_VERSION
  }
}
